import { useEffect, useRef, useState } from 'react';

export const useNftsPageSize = () => {
  const defaultNftsCount = 10;
  const elementRef = useRef<HTMLDivElement>(null);
  const [pageSize, setPageSize] = useState<number>();
  const defaultCardWidth = 255;
  const defaultCardHeight = 492;

  useEffect(() => {
    if (!elementRef.current || pageSize) {
      return;
    }

    const width = elementRef.current.clientWidth + 5;
    const height = elementRef.current.clientHeight + 5;
    const columns = Math.ceil(width / defaultCardWidth);
    const rows = Math.ceil(height / defaultCardHeight);
    const nftsCount = columns * rows;

    setPageSize(nftsCount < defaultNftsCount ? defaultNftsCount : nftsCount);
  }, [elementRef]);

  return { elementRef, pageSize };
};
